<section class="content">
    <div class="container-fluid">
        <form class="col-lg-12" [formGroup]="platformForm">
            <mat-accordion displayMode="flat" [multi]="true">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>General</mat-panel-title>
                        <mat-panel-description>
                            Configuration Platform
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="platform">

                        <mat-form-field class="col-md-12">
                            <mat-label>Name</mat-label>
                            <input matInput type="text" formControlName="name" />
                        </mat-form-field>

                        <section formGroupName="lang">
                            <mat-label>Langs</mat-label>
                            <mat-selection-list class="col-md-12 mb-3" formControlName="available">
                                <mat-label>Available languages</mat-label>
                                <mat-list-option value="fr" checkboxPosition="before">
                                    French
                                </mat-list-option>
                                <mat-list-option value="en" checkboxPosition="before">
                                    English
                                </mat-list-option>
                            </mat-selection-list>

                            <mat-radio-group class="col-md-12" formControlName="default">
                                <mat-label>Default language</mat-label>
                                <div class="radio-wrap mt-2">
                                    <mat-radio-button value="fr" [disabled]="!availableLangs.includes('fr')">
                                        French
                                    </mat-radio-button>
                                    <mat-radio-button value="en" [disabled]="!availableLangs.includes('en')">
                                        English
                                    </mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </section>

                        <div class="col-md-12 spacer-top-s mb-4">
                            <mat-slide-toggle
                              formControlName="emailChannelAutoSubscription">
                              [DEPRECATED] Subscribe new user to email notifications (now it's enabled by default and this param is not used)
                            </mat-slide-toggle>
                          </div>

                        <div class="col-md-12 mb-4">
                            <mat-slide-toggle formControlName="frenchLanguageCharterBanner">
                                Display Charter of french Language banner for Quebec cities
                            </mat-slide-toggle>
                        </div>

                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Family</mat-panel-title>
                                <mat-panel-description>
                                    Family configuration
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div formGroupName="family">
                                <!-- Links control -->
                                <mat-form-field class="col-md-12">
                                    <mat-label>Links</mat-label>
                                    <mat-select formControlName="links" multiple>
                                        <mat-option *ngFor="let link of familyLinks" [value]="link">
                                            {{ link }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
    
                                <!-- Proof of Identity Count control -->
                                <mat-form-field class="col-md-12">
                                    <mat-label>Proof of Identity Count</mat-label>
                                    <input matInput type="number" formControlName="proofOfIdentityCount" />
                                </mat-form-field>
    
    
                                <!-- Max Family Member control -->
                                <mat-form-field class="col-md-12">
                                    <mat-label>Max Family Member</mat-label>
                                    <input matInput type="number" formControlName="maxFamilyMember" />
                                </mat-form-field>
    
                                <!-- Expiration controls -->
                                <mat-expansion-panel [expanded]="true" formGroupName="expiration">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title> Link Expiration </mat-panel-title>
                                      </mat-expansion-panel-header>
                                    <!-- Age Range control -->
                                    <mat-form-field class="col-md-12 age-range-field" formArrayName="ageRange" >
                                        <mat-label>Age Range</mat-label>
    
                                        <input matInput type="number" [formControlName]="0" placeholder="Start Age" />
                                        <h4>-</h4>
                                        <input matInput type="number" [formControlName]="1" placeholder="End Age" />
                                    </mat-form-field>
                                     
    
                                    <!-- Duration control -->
                                    <mat-form-field class="col-md-12">
                                        <mat-label>Duration (years)</mat-label>
                                        <input matInput type="number" formControlName="duration" />
                                    </mat-form-field>
    
                                    <!-- Notice Delay control -->
                                    <mat-form-field class="col-md-12">
                                        <mat-label>Notice Delay (days)</mat-label>
                                        <input matInput type="number" formControlName="noticeDelay" />
                                    </mat-form-field>
                                </mat-expansion-panel>
    
                                <!-- Instructions controls -->
                                <!-- <section formGroupName="instructions">
                                    <mat-form-field class="col-md-12">
                                        <mat-label>Instructions (fr)</mat-label>
                                        <textarea matInput formControlName="fr"></textarea>
                                    </mat-form-field>
                                </section> -->
    
                            </div>
                        </mat-expansion-panel>


                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Modules</mat-panel-title>
                                <mat-panel-description>
                                    Modules Options
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <mat-selection-list formControlName="modules" class="col-md-12">
                                <div *ngFor="let module of modules" class="d-flex flex-column">
                                    <mat-list-option
                                        [value]="module"
                                        checkboxPosition="before"
                                    >
                                        {{ module }}
                                    </mat-list-option>
                                    <div class="consultation-provider" *ngIf="module === 'CONSULTATION' && modulesControl.value?.includes('CONSULTATION')">
                                    <div formGroupName="consultation">
                                        <mat-radio-group class="col-md-12" formControlName="provider">
                                        <div class="consultation-radio-wrap">
                                            <mat-radio-button
                                            value="BCITI"
                                            >
                                            bciti
                                            </mat-radio-button>
                                            <mat-radio-button
                                                value="COCORIKO"
                                            >
                                            Cocoriko
                                            </mat-radio-button>
                                            <mat-radio-button
                                                value="ZEN_CITY"
                                            >
                                            Zen City
                                            </mat-radio-button>
                                        </div>
                                        </mat-radio-group>
    
                                        <mat-form-field class="consultation-access-type" appearance="standard">
                                            <mat-label>Access type</mat-label>
                                            <mat-select formControlName="accessType">
                                            <mat-option
                                                *ngFor="let option of consultationConnectorAccessType"
                                                [value]="option"
                                            >
                                                {{ option }}
                                            </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    </div>
                                </div>
                            </mat-selection-list>
                        </mat-expansion-panel>

                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Card Options</mat-panel-title>
                                <mat-panel-description>
                                    Card Options
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div formGroupName="cardPrint">
                                <div class="col-md-12">
                                    Card Print :
                                </div>
                                <div class="col-md-12">
                                    <mat-slide-toggle formControlName="canUserPrintCitizenCard">
                                        User can print his citizen (or legacy) card
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </mat-expansion-panel>



                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Profile Options</mat-panel-title>
                                <mat-panel-description>
                                    Profile Options
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div formGroupName="profileOptions">
                                <div class="col-md-12">
                                    All profile fields are shown by default. <br>
                                    If you want <strong>to hide</strong> one specific profile field on admin and user side (user profile page / user-record search / profile admin search tab ), select them below :
                                </div>
                                <mat-selection-list class="d-flex flex-wrap" formControlName="hiddenFields">
                                    <mat-list-option *ngFor="let hiddenField of hiddenFieldsList"
                                    class="flex-fill"
                                    [value]="hiddenField"
                                    checkboxPosition="before">
                                    {{ hiddenField }}
                                </mat-list-option>
                                </mat-selection-list>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Dashboard</mat-panel-title>
                                <mat-panel-description>
                                    Dashboard Configuration
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="col-md-12">
                                Add dashboard link for cities.<br>
                                Expected format: <i>https://charts.mongodb.com/charts-bciti-prod-lfxly/embed/dashboards?id=<strong>DASHBOARD_ID</strong></i> <br>
                                Replace <strong>DASHBOARD_ID</strong> by the id of the dashboard you want to display. You can retrieve it on the dashboard url.  <br>
                                Do not forget to active dashboard module by adding dashboard menu item for admin-side menu of the organization after save.
                            </div>
                                <mat-selection-list class="d-flex flex-wrap flex-column" formGroupName="dashboardUrl">
                                    <mat-form-field class="lang-input-wrapper mb-3">
                                        <mat-label>Dashboard link FR</mat-label>
                                        <input matInput type="text" formControlName="fr" [disabled]="!availableLangs.includes('fr')">
                                    </mat-form-field>
                                    <mat-form-field class="lang-input-wrapper mb-3">
                                        <mat-label>Dashboard link EN</mat-label>
                                        <input matInput type="text" formControlName="en" [disabled]="!availableLangs.includes('en')">
                                    </mat-form-field>
                                </mat-selection-list>
                        </mat-expansion-panel>
                    </section>

                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Output</mat-panel-title>
                        <mat-panel-description>
                            JSON
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <pre>{{ platform | json }}</pre>
                </mat-expansion-panel>
                

            </mat-accordion>
            <div class="actions" *ngIf="displayActions">
                <div class="warning" *ngIf="platform?.dirty">You have unsaved changes.</div>
                <div>
                    <mat-spinner [diameter]="36" *ngIf="loading"></mat-spinner>
                </div>
                <button mat-raised-button [disabled]="loading" (click)="submitPlatform()" color="primary">
                    Save
                </button>
            </div>
        </form>
    </div>
</section>